<template>
  <ul class="Pagination">
    <!-- <li class="Pagination-item">
      <button
        class="Pagination-link"
        type="button"
        @click="onClickFirstPage"
        :disabled="isInFirstPage"
        aria-label="Go to first page"
      >
        First
      </button>
    </li> -->

    <li class="Pagination-item">
      <a
        class="Pagination-link Pagination-link--prevnext"
        :class="{ 'is-disabled': isInFirstPage }"
        :href="!isInFirstPage ? `?${path}${path ? '&' : ''}page=${page - 1}` : null"
        aria-label="Go to previous page"
        @click.prevent="onClickPreviousPage"
        role="button"
      >
        <icon name="double-arrow-left"/>
      </a>
    </li>

    <li v-for="page in pages" class="Pagination-item" :key="page.name">
      <a
        class="Pagination-link"
        :class="{ 'is-current': isPageActive(page.name) }"
        :href="`?${path}${path ? '&' : ''}page=${page.name}`"
        :aria-label="`Go to page number ${page.name}`"
        @click.prevent="onClickPage(page.name)"
        role="button"
      >
        {{ page.name }}
      </a>
    </li>

    <li class="Pagination-item">
      <a
        class="Pagination-link Pagination-link--prevnext"
        :href="!isInLastPage ? `?${path}${path ? '&' : ''}page=${page + 1}` : null"
        :class="{ 'is-disabled': isInLastPage }"
        aria-label="Go to next page"
        @click.prevent="onClickNextPage"
        role="button"
      >
        <icon name="double-arrow-right"/>
      </a>
    </li>

    <!-- <li class="pagination-item">
      <button
       class="Pagination-link"
        type="button"
        @click="onClickLastPage"
        :disabled="isInLastPage"
        aria-label="Go to last page"
      >
        Last
      </button>
    </li> -->
  </ul>
</template>

<script>
import Icon from './Icon.vue';
export default {
  components: {
    Icon,
  },

  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 5,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    path: {
      type: String,
      required: true,
    }
  },

  computed: {
    startPage() {
      if (this.page === 1) {
        return 1;
      }

      if (this.page > this.totalPages - this.maxVisibleButtons + 1) {
        let startPage = this.totalPages - this.maxVisibleButtons + 1;
        if(startPage < 1)
            startPage = 1;
        return startPage;
      }

      return this.page - 1;
    },

    endPage() {
      return Math.min(
        this.startPage + this.maxVisibleButtons - 1,
        this.totalPages
      );
    },

    pages() {
      const range = [];

      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.page,
        });
      }

      return range;
    },

    isInFirstPage() {
      return this.page === 1;
    },

    isInLastPage() {
      return this.page === this.totalPages;
    },
  },

  methods: {
    onClickFirstPage() {
      this.$emit("page-changed", 1);
    },
    onClickPreviousPage() {
      this.$emit("page-changed", this.page - 1);
    },
    onClickPage(page) {
      this.$emit("page-changed", page);
    },
    onClickNextPage() {
      this.$emit("page-changed", this.page + 1);
    },
    onClickLastPage() {
      this.$emit("page-changed", this.totalPages);
    },
    isPageActive(page) {
      return this.page === page;
    },
  },
};
</script>